import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const LanguageHreflang = () => {
  const location = useLocation();
  const origin = window.location.origin;
  
  // Strip lang prefix for base path
  const pathParts = location.pathname.split('/');
  const isPrefixed = ['pt', 'en', 'es'].includes(pathParts[1]);
  const basePath = isPrefixed ? '/' + pathParts.slice(2).join('/') : location.pathname;
  
  const cleanPath = basePath === '/' ? '' : basePath;

  return (
    <Helmet>
      <link rel="alternate" hrefLang="pt" href={`${origin}/pt${cleanPath}`} />
      <link rel="alternate" hrefLang="en" href={`${origin}/en${cleanPath}`} />
      <link rel="alternate" hrefLang="es" href={`${origin}/es${cleanPath}`} />
      <link rel="alternate" hrefLang="x-default" href={`${origin}/pt${cleanPath}`} />
    </Helmet>
  );
};

export default LanguageHreflang;